import { createSlice } from "@reduxjs/toolkit";
import { DEFAULT } from '../../config/data';

const initialState = {
    volume: DEFAULT.DEFAULT_SETTINGS.volume, // Volume state
    playStatus: DEFAULT.DEFAULT_SETTINGS.playStatus, // Play status state
    audioSrc: '',
    filters: [],
    userSetting: [],
    question: [],
    questionId: 0,
    globalMode: 'question',
};

const eqFiltersSlice = createSlice({
    name: 'filters',
    initialState,
    reducers: {

        initialize: (state, action) => {
            const { id, audioSrc, filters } = action.payload;
            state.questionId = id;
            state.volume = DEFAULT.DEFAULT_SETTINGS.volume;
            state.playStatus = DEFAULT.DEFAULT_SETTINGS.playStatus;
            state.audioSrc = audioSrc; // Set the audio source
            state.filters = filters; // Set the filters for processing
            state.question = filters; // Set the question filters
            state.userSetting = Array.from({ length: filters.length }, (_, i) => 
                DEFAULT.DEFAULT_FILTER[i % DEFAULT.DEFAULT_FILTER.length]
            );
            state.globalMode = 'question'; // Set the global mode to question
        },

        setFilters: (state, action) => {
            state.filters = action.payload;
        },

        setVolume: (state, action) => {
            state.volume = action.payload; // Update volume globally
        },

        setPlayStatus: (state, action) => {
            state.playStatus = action.payload; // Update play status globally
        },

        // Updates the audio source
        setAudioSource: (state, action) => {
            state.audioSrc = action.payload;
        },
        

        // Updates the user-defined filter settings
        setUserSetting: (state, action) => {
            state.userSetting = action.payload;
            if (state.globalMode === 'user-setting') {
                state.filters = action.payload; // Sync filters if in user-setting mode
            }
        },

        // Sets the global mode and updates filters accordingly
        setGlobalMode: (state, action) => {
            state.globalMode = action.payload;
            switch (action.payload) {
                case 'pure-audio':
                    state.filters = []; // Clear filters for pure audio
                    break;
                case 'question':
                    state.filters = [...state.question]; // Apply question filters
                    break;
                case 'user-setting':
                    state.filters = [...state.userSetting]; // Apply user-defined filters
                    break;

                case 'check':
                    state.filters = [];
                    state.playStatus = false;
                    break;
                default:
                    break;
            }
        },

        // Updates a specific filter property
        updateFilter: (state, action) => {
            const { index, key, value } = action.payload;
            if (state.filters[index]) {
                state.filters[index][key] = value;
            }
        },

        // Updates a specific user setting property
        updateUserSetting: (state, action) => {
            const { index, key, value } = action.payload;
            if (state.userSetting[index]) {
                state.userSetting[index][key] = value;
            }
            if (state.globalMode === 'user-setting' && state.filters[index]) {
                state.filters[index][key] = value; // Sync filters if in user-setting mode
            }
        },
    },
});

export const {
    initialize,
    setFilters,
    setVolume,
    setPlayStatus,
    setAudioSource,
    setGlobalMode,
    setUserSetting,
    updateFilter,
    updateUserSetting,
} = eqFiltersSlice.actions;

export default eqFiltersSlice.reducer;